export default function ConfigureThermostat() {
  // TODO: create configure thermostat device page
  return <></>
}
